import { GALoggerService } from 'src/app/share/service/galogger.service';
import { checkIsMobile, TmModalComponent } from '@techmore/global';
import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, NgZone, AfterViewInit, PLATFORM_ID, ViewChild, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { loadLazyJsFile, parseQueryPqrams } from 'src/app/util';

@Component({
  selector: 'app-share-social-modal',
  templateUrl: './share-social-modal.component.html',
  styleUrls: ['./share-social-modal.component.scss']
})
export class ShareSocialModalComponent implements AfterViewInit {
  @ViewChild('modal', {static: false}) modal: TmModalComponent;
  /** 是否為瀏覽器端渲染 */
  isBrowser: boolean;
  /** 彈出視窗是否開啟中 */
  isOpened = false;
  /** 本頁的 url */
  pageUrl: string;

  constructor(
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected router: Router,
    protected route: ActivatedRoute,
    protected el: ElementRef,
    protected zone: NgZone,
    protected renderer: Renderer2,
    protected gALoggerService: GALoggerService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      window['onClassroomShare'] = () => {
        this.logtoGA('google_classroom');
      };
    }
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      if (location.href.indexOf('/subject/') !== -1) {
        // 主題頁
        this.pageUrl = location.href;
      } else {
        // 素材頁
        const qp = parseQueryPqrams(location.search);
        this.pageUrl = `${location.origin}${location.pathname}?indexCode=${qp['indexCode']}&id=${qp['id'] }`;
      }
    }
  }

  logtoGA(socialType: string) {
    if (this.isBrowser) {
      if (this.pageUrl.indexOf('/subject/') !== -1) {
        // 主題頁
        const themeId = location.pathname.split('/')[3];
        this.gALoggerService.log({
          event: 'share_theme',
          'share_social': socialType,
          'page_id': themeId,
        });
      } else {
        // 素材頁
        this.gALoggerService.log({
          event: 'share_material',
          'share_social': socialType,
          'page_id': this.route.snapshot.queryParams['id'],
          'fetch_index': this.route.snapshot.queryParams['indexCode'],
        });
      }
    }
  }

  share2FB() {
    const isMobile = checkIsMobile();
    if (isMobile) {
      // 嘗試打開 Facebook 應用
      // const facebookAppUrl = 'fb://facewebmodal/f?href=' + encodeURIComponent(this.pageUrl);
      
      // // 一個技巧：設置超時，如果超過一定時間還沒跳轉成功，就使用網頁版分享
      // const timeout = setTimeout(() => {
        window.open(
          'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(this.pageUrl),
          '_blank'
        );
      // }, 1000);
      
      // window.location.href = facebookAppUrl;
      
      // // 如果成功跳轉到應用，就清除超時
      // window.addEventListener('pagehide', () => {
      //   clearTimeout(timeout);
      // }, { once: true });
    } else {
      // 桌面版分享
      window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.pageUrl),
        '_blank',
        'height=500,resizable=yes,scrollbars=yes,width=700'
      );
    }
  }

  /** 開啟視窗 */
  open() {
    this.modal.open();
  }

  /** 關閉視窗 */
  close() {
    this.modal.close();
  }

  /** 複製到剪貼簿 */
  copyToClipBoard(el: HTMLElement) {
    if ((document.body as any).createTextRange) { // IE
      const range = (document.body as any).createTextRange();
      range.moveToElementText(el);
      range.select();
      document.execCommand('Copy');
    } else if (window.getSelection) {
      // other browsers
      const range = document.createRange();
      // range.selectNodeContents(elemID);
      range.selectNode(el);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
    }
  }
}
